<template>
  <header
    class="main-header"
    :class="{ 'is-open': megaOpen, 'is-subpage': isSubpage, 'mobile-open': mobileMenuOpen }"
    @mouseleave="megaOpen = false"
  >
    <!-- 1단: 로고 중앙 + 우측 전화 -->
    <div class="top-bar">
      <div class="top-inner">
        <!-- 방문자 카운터: 1단 아래로 탭처럼 매달림 (전화번호와 오른쪽 정렬) -->
        <div class="visit-counter">
          <span class="visit-item">TODAY <strong>{{ dailyVisit.toLocaleString() }}</strong></span>
          <span class="visit-divider">|</span>
          <span class="visit-item">TOTAL <strong>{{ totalVisit.toLocaleString() }}</strong></span>
        </div>
        <div class="top-side top-left">
          <div class="grand-open">
            <span class="go-text">GRAND OPEN</span>
          </div>
        </div>
        <router-link to="/" class="logo" @click="closeMobileMenu">
          <img :src="logoSrc" alt="용인남사 대우이안 플렉시티" class="logo-img" />
        </router-link>
        <div class="top-side top-right">
          <router-link to="/reservation/register" class="register-link">
            <span class="register-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <line x1="19" y1="8" x2="19" y2="14"/>
                <line x1="16" y1="11" x2="22" y2="11"/>
              </svg>
            </span>
            <span class="register-text">관심고객등록</span>
          </router-link>
          <a href="tel:1644-4220" class="phone-btn">
            <span class="phone-icon-wrap">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.11 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
            </span>
            <span class="phone-num">1644-4220</span>
          </a>
          <!-- 모바일 햄버거 버튼 -->
          <button
            class="hamburger-btn"
            :class="{ 'is-active': mobileMenuOpen }"
            @click="toggleMobileMenu"
            aria-label="메뉴 열기"
          >
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 2단: 메뉴 full-width 균등 + 방문자수 오른쪽 끝 (데스크톱 전용) -->
    <div class="menu-bar">
      <div class="menu-bar-outer">
        <nav class="menu-nav" @mouseenter="megaOpen = true">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="menu-item"
            @mouseenter="activeMenu = index"
          >
            <router-link
              :to="menu.children[0].path"
              class="menu-link"
              :class="{ active: megaOpen && activeMenu === index }"
              @click="megaOpen = false"
            >{{ menu.title }}</router-link>
          </div>
        </nav>
      </div>
    </div>

    <!-- 메가메뉴: 전체 서브메뉴 동시 노출 (데스크톱) -->
    <div class="mega-panel" :class="{ 'is-visible': megaOpen }">
      <div class="mega-panel-outer">
        <div class="mega-grid">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="mega-col"
          >
            <ul class="sub-list">
              <li v-for="(sub, si) in menu.children" :key="si">
                <router-link :to="sub.path" class="sub-link" @click="megaOpen = false">{{ sub.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- 방문자수 자리만큼 빈 공간 -->
        <div class="mega-spacer"></div>
      </div>
    </div>

    <!-- 모바일 풀스크린 메뉴 -->
    <div class="mobile-menu" :class="{ 'is-visible': mobileMenuOpen }">
      <div class="mobile-menu-inner">
        <nav class="mobile-nav">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="mobile-menu-group"
          >
            <button
              class="mobile-menu-title"
              :class="{ 'is-expanded': expandedMenu === index }"
              @click="toggleAccordion(index)"
            >
              <span>{{ menu.title }}</span>
              <svg class="mobile-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            <div class="mobile-sub-list" :class="{ 'is-expanded': expandedMenu === index }">
              <router-link
                v-for="(sub, si) in menu.children"
                :key="si"
                :to="sub.path"
                class="mobile-sub-link"
                @click="closeMobileMenu"
              >{{ sub.title }}</router-link>
            </div>
          </div>
        </nav>
        <div class="mobile-menu-footer">
          <a href="tel:1644-4220" class="mobile-phone-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.11 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            <span>1644-4220</span>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
  computed: {
    isSubpage() {
      return this.$route.path !== '/'
    },
    logoSrc() {
      if (this.isSubpage || this.megaOpen || this.mobileMenuOpen) {
        return require('@/assets/logo/logo_symbol.png')
      }
      return require('@/assets/logo/logo_white.png')
    }
  },
  data() {
    return {
      megaOpen: false,
      activeMenu: 0,
      mobileMenuOpen: false,
      expandedMenu: null,
      dailyVisit: 0,
      totalVisit: 0,
      visitTimer: null,
      menuData: [
        {
          title: '사업안내',
          children: [
            { title: '사업개요', path: '/intro/overview' },
            { title: '브랜드', path: '/intro/brand' }
          ]
        },
        {
          title: '입지안내',
          children: [
            { title: '입지환경', path: '/location/environment' }
          ]
        },
        {
          title: '상품안내',
          children: [
            { title: '단지배치도', path: '/product/layout' },
            { title: '동호수 배치도', path: '/product/unit-map' },
            { title: '프리미엄', path: '/product/premium' },
            { title: '커뮤니티', path: '/product/community' }
          ]
        },
        {
          title: '세대안내',
          children: [
            { title: '49㎡A', path: '/type/49A' },
            { title: '49㎡B', path: '/type/49B' },
            { title: '59㎡A', path: '/type/59A' },
            { title: '59㎡B', path: '/type/59B' },
            { title: '84㎡A', path: '/type/84A' },
            { title: '84㎡B', path: '/type/84B' }
          ]
        },
        {
          title: '홍보센터',
          children: [
            { title: '이벤트', path: '/media/event' },
            { title: '이벤트 당첨자', path: '/media/winner' },
            { title: '홍보영상', path: '/media/video' },
            { title: '언론보도', path: '/media/press' }
          ]
        },
        {
          title: '관심고객등록',
          children: [
            { title: '관심고객등록', path: '/reservation/register' },
            { title: '오시는길', path: '/reservation/location' }
          ]
        }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
        this.expandedMenu = null
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      document.body.style.overflow = ''
      this.expandedMenu = null
    },
    toggleAccordion(index) {
      this.expandedMenu = this.expandedMenu === index ? null : index
    },
    initVisitCounter() {
      const STORAGE_KEY = 'ecofore_visit'
      const now = new Date()
      const todayStr = now.toISOString().slice(0, 10)
      const currentMinute = now.getHours() * 60 + now.getMinutes()

      // localStorage에서 저장된 데이터 확인
      let saved = null
      try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) } catch(e) { /* ignore */ }

      // 날짜가 다르면 저장 데이터 초기화
      if (saved && saved.date !== todayStr) saved = null

      // 기준일: 2026-04-16, 기준 누적: 2500, 하루 평균: 400
      const baseDate = new Date('2026-04-16T00:00:00')
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const daysPassed = Math.floor((todayStart - baseDate) / (1000 * 60 * 60 * 24))
      const seed = todayStart.getTime()
      const dailyTarget = 370 + (seed % 61)

      // 시간대별 가중치 (새벽 적고, 낮~저녁 많음)
      const hour = now.getHours()
      const weights = [0.01,0.01,0.005,0.005,0.005,0.01,0.02,0.04,0.06,0.07,0.08,0.08,0.07,0.06,0.06,0.07,0.07,0.06,0.05,0.04,0.03,0.03,0.02,0.01]
      let cumulative = 0
      for (let h = 0; h < hour; h++) cumulative += weights[h]
      cumulative += weights[hour] * (now.getMinutes() / 60)

      // 날짜+시간 기반 고정 jitter (랜덤 아님)
      const minuteSeed = seed + currentMinute
      const jitter = (minuteSeed % 11) - 5

      let calcDaily = Math.max(0, Math.floor(dailyTarget * cumulative) + jitter)
      const baseTotalVisit = 2500
      const pastDaysTotal = daysPassed > 0 ? daysPassed * 400 + (seed % 50) : 0
      let calcTotal = baseTotalVisit + pastDaysTotal + calcDaily

      // 저장된 값보다 작아지면 안 됨 (절대 줄어들지 않음)
      if (saved) {
        calcDaily = Math.max(calcDaily, saved.daily)
        calcTotal = Math.max(calcTotal, saved.total)
      }

      this.dailyVisit = calcDaily
      this.totalVisit = calcTotal

      // localStorage에 저장
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          date: todayStr,
          minute: currentMinute,
          daily: this.dailyVisit,
          total: this.totalVisit
        }))
      } catch(e) { /* ignore */ }
    },
    saveVisitCount() {
      const now = new Date()
      try {
        localStorage.setItem('ecofore_visit', JSON.stringify({
          date: now.toISOString().slice(0, 10),
          minute: now.getHours() * 60 + now.getMinutes(),
          daily: this.dailyVisit,
          total: this.totalVisit
        }))
      } catch(e) { /* ignore */ }
    }
  },
  mounted() {
    this.initVisitCounter()
    this.visitTimer = setInterval(() => {
      const inc = Math.floor(Math.random() * 3) + 1
      this.dailyVisit += inc
      this.totalVisit += inc
      this.saveVisitCount()
    }, Math.floor(Math.random() * 3000) + 5000)
  },
  beforeUnmount() {
    document.body.style.overflow = ''
    if (this.visitTimer) clearInterval(this.visitTimer)
  }
}
</script>

<style scoped>
.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* ===== 1단: 로고 바 ===== */
.top-bar {
  background: transparent;
  transition: background 0.35s ease;
  position: relative;
  z-index: 1001;
}

.main-header.is-open .top-bar {
  background: #fff;
}

.top-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 14px 20px;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.top-side { flex: 1; }
.top-left {
  display: flex;
  align-items: center;
  margin-left: -70px;
}
.top-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-right: -70px;
}

/* GRAND OPEN (맨 왼쪽 끝) */
.grand-open {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.go-dot {
  width: 8px;
  height: 8px;
  background: var(--ecofore-primary);
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(140, 199, 81, 0.7);
  animation: go-pulse 1.6s ease-in-out infinite;
  flex-shrink: 0;
}

.go-text {
  font-family: var(--font-paperlogy);
  font-size: 22px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.8px;
  line-height: 1;
}

@keyframes go-pulse {
  0% { box-shadow: 0 0 0 0 rgba(140, 199, 81, 0.7); }
  70% { box-shadow: 0 0 0 10px rgba(140, 199, 81, 0); }
  100% { box-shadow: 0 0 0 0 rgba(140, 199, 81, 0); }
}

.main-header.is-open .go-text,
.main-header.is-subpage .go-text {
  color: var(--ecofore-accent);
}


/* 관심고객등록 링크 (좌측) */
.register-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #fff;
  transition: opacity 0.3s ease;
}

.register-link:hover {
  opacity: 0.8;
}

.register-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--ecofore-accent);
  border-radius: 50%;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 70, 83, 0.35);
}

.register-text {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.2px;
}

.main-header.is-open .register-link,
.main-header.is-subpage .register-link {
  color: #222;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.logo-img {
  height: 56px;
  width: auto;
  object-fit: contain;
  transition: all 0.35s ease;
}

/* 전화 (후킹 스타일) */
.phone-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #fff;
  padding: 4px 14px 4px 4px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: all 0.3s ease;
}

.phone-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
}

.phone-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--ecofore-accent);
  border-radius: 50%;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 70, 83, 0.35);
  flex-shrink: 0;
}

.phone-num {
  font-family: var(--font-paperlogy);
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0;
}

.main-header.is-open .phone-btn,
.main-header.is-subpage .phone-btn {
  color: #222;
  background: #f6f6f6;
  border-color: #e2e2e2;
}

.main-header.is-open .phone-btn:hover,
.main-header.is-subpage .phone-btn:hover {
  background: #efefef;
}

/* ===== 2단: 메뉴 바 ===== */
.menu-bar {
  background: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.35s ease;
}

.main-header.is-open .menu-bar {
  background: #fff;
  border-top-color: #e8e8e8;
  border-bottom-color: #e8e8e8;
}

.menu-bar-outer {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
  display: flex;
  align-items: center;
}

/* 메뉴 — 중앙 모음 */
.menu-nav {
  display: flex;
  width: 70%;
  margin: 0 auto;
}

.menu-item {
  flex: 1;
  text-align: center;
}

.menu-link {
  display: block;
  padding: 14px 0;
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  letter-spacing: 0.3px;
  transition: color 0.2s ease;
  position: relative;
}

.menu-link:hover,
.menu-link.active {
  color: #fff;
}

.menu-link.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--ecofore-accent);
}

/* 열렸을 때 메뉴 색상 */
.main-header.is-open .menu-link {
  color: #666;
}

.main-header.is-open .menu-link:hover,
.main-header.is-open .menu-link.active {
  color: #111;
  font-weight: 600;
}

/* 방문자수 — 1단 아래로 탭처럼 매달림 (위 각, 아래 둥글) */
.visit-counter {
  position: absolute;
  bottom: 0;
  right: -50px;
  transform: translateY(100%);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #fff;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
  transition: background 0.3s ease, box-shadow 0.3s ease, border-radius 0.3s ease;
  z-index: 2;
}

.main-header:hover .visit-counter,
.main-header.is-open .visit-counter,
.main-header.is-subpage .visit-counter {
  background: transparent;
  box-shadow: none;
  border-radius: 0;
}

.visit-item {
  font-family: var(--font-paperlogy);
  font-size: 13px;
  font-weight: 500;
  color: #555;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.visit-item strong {
  font-family: var(--font-paperlogy);
  font-weight: 700;
  color: var(--ecofore-accent);
  margin-left: 5px;
  font-size: 14px;
}

.visit-divider {
  color: #d0d0d0;
  font-size: 13px;
}

/* ===== 메가메뉴 ===== */
.mega-panel {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  opacity: 0;
}

.mega-panel.is-visible {
  max-height: 400px;
  opacity: 1;
}

.mega-panel-outer {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
  display: flex;
}

.mega-grid {
  display: flex;
  width: 70%;
  margin: 0 auto;
  padding: 24px 0 32px;
}

.mega-col {
  flex: 1;
  text-align: center;
}

.mega-spacer {
  display: none;
}

.sub-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}


.sub-link {
  display: inline-block;
  padding: 6px 12px;
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: #444;
  text-decoration: none;
  transition: color 0.2s ease, background 0.2s ease;
  border-radius: 3px;
}

.sub-link:hover {
  color: var(--ecofore-accent);
  background: rgba(140, 199, 81, 0.06);
}

/* ===== 서브페이지 ===== */
.main-header.is-subpage .top-bar {
  background: #fff;
}


.main-header.is-subpage .phone-btn {
  color: #555;
  border-color: #ddd;
}

.main-header.is-subpage .phone-btn:hover {
  color: var(--ecofore-accent);
  border-color: var(--ecofore-accent);
  background: rgba(140, 199, 81, 0.05);
}

.main-header.is-subpage .menu-bar {
  background: #fff;
  border-top-color: #e8e8e8;
  border-bottom-color: #e8e8e8;
}

.main-header.is-subpage .menu-link {
  color: #666;
}

.main-header.is-subpage .menu-link:hover,
.main-header.is-subpage .menu-link.active {
  color: #111;
  font-weight: 600;
}

/* ===== 반응형 ===== */
@media (max-width: 1100px) {
  .menu-link { font-size: 14px; }
  .sub-link { font-size: 13px; }
  .visit-counter { display: none; }
  .mega-spacer { display: none; }
}

@media (max-width: 900px) {
  .top-inner { padding: 14px 20px; min-height: 72px; }
  .menu-bar-outer { padding: 0 20px; }
  .menu-link { padding: 12px 0; font-size: 13px; }
  .phone-num { display: none; }
  .phone-btn { padding: 8px; border-radius: 50%; }
}

/* ============================================
   햄버거 버튼 (데스크톱에서는 숨김)
   ============================================ */
.hamburger-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  margin-left: 8px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 5px;
  -webkit-tap-highlight-color: transparent;
}

.hamburger-line {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* 서브페이지 / 메뉴열림 시 햄버거 색상 */
.main-header.is-subpage .hamburger-line,
.main-header.mobile-open .hamburger-line {
  background: #333;
}

/* 햄버거 → X 애니메이션 */
.hamburger-btn.is-active .hamburger-line:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.hamburger-btn.is-active .hamburger-line:nth-child(2) {
  opacity: 0;
}
.hamburger-btn.is-active .hamburger-line:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ============================================
   모바일 풀스크린 메뉴 (데스크톱에서는 숨김)
   ============================================ */
.mobile-menu {
  display: none;
}

/* ============================================
   모바일 반응형 (max-width: 768px)
   ============================================ */
@media (max-width: 768px) {
  /* ==========================================
     모바일 전용 헤더 — 재구성
     [햄버거] --- [로고 중앙] --- [전화아이콘]
     ========================================== */

  /* --- 데스크톱 요소 숨김 --- */
  .menu-bar { display: none; }
  .mega-panel { display: none; }
  .visit-counter { display: none; }
  .grand-open { display: none; }
  .register-link { display: none; }
  .phone-btn { display: none; }

  /* --- 탑바 컴팩트하게 --- */
  .top-inner {
    padding: 0 16px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0;
  }

  /* 왼쪽 섹션 완전 숨김 (GRAND OPEN 등) */
  .top-side.top-left {
    display: none !important;
  }

  /* 오른쪽: 햄버거만 */
  .top-side.top-right {
    display: flex;
    flex: 0 0 auto;
    min-width: auto;
    justify-content: flex-end;
    align-items: center;
    gap: 0;
    margin: 0;
  }

  /* --- 햄버거 --- */
  .hamburger-btn {
    display: flex;
    margin-left: 0;
    width: 40px;
    height: 40px;
  }

  /* --- 로고 왼쪽 --- */
  .main-header .logo {
    position: static !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    margin: 0 !important;
  }

  .logo-img {
    height: 22px;
  }

  /* --- 오른쪽: 햄버거만 --- */
  .top-side.top-right {
    flex: 0 0 auto;
    min-width: auto;
    gap: 0;
    margin: 0;
  }

  .phone-num { display: none; }

  /* --- 메뉴 열림/서브페이지 시 헤더 흰 배경 --- */
  .main-header.mobile-open .top-bar,
  .main-header.is-subpage .top-bar {
    background: #fff;
  }

  .main-header.mobile-open .logo-img {
    height: 24px;
  }

  /* --- 모바일 풀스크린 메뉴 --- */
  .mobile-menu {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;
    padding-top: 56px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    transform: translateX(100%);
    transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    visibility: hidden;
  }

  .mobile-menu.is-visible {
    transform: translateX(0);
    visibility: visible;
  }

  .mobile-menu-inner {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 56px);
    padding: 16px 0 32px;
  }

  /* --- 모바일 네비게이션 --- */
  .mobile-nav {
    flex: 1;
  }

  .mobile-menu-group {
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-menu-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 24px;
    min-height: 52px;
    font-family: var(--font-pretendard);
    font-size: 17px;
    font-weight: 600;
    color: #222;
    background: none;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-menu-title:active {
    background: #f8f8f8;
  }

  .mobile-arrow {
    color: #999;
    transition: transform 0.3s ease;
    flex-shrink: 0;
  }

  .mobile-menu-title.is-expanded .mobile-arrow {
    transform: rotate(180deg);
    color: var(--ecofore-accent);
  }

  .mobile-menu-title.is-expanded {
    color: var(--ecofore-accent);
  }

  /* --- 모바일 서브메뉴 아코디언 --- */
  .mobile-sub-list {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    background: #fafafa;
  }

  .mobile-sub-list.is-expanded {
    max-height: 400px;
  }

  .mobile-sub-link {
    display: block;
    padding: 14px 24px 14px 40px;
    min-height: 44px;
    font-family: var(--font-pretendard);
    font-size: 15px;
    font-weight: 400;
    color: #555;
    text-decoration: none;
    transition: color 0.2s ease, background 0.2s ease;
    line-height: 1;
    display: flex;
    align-items: center;
  }

  .mobile-sub-link:active {
    background: #f0f0f0;
    color: var(--ecofore-accent);
  }

  /* --- 모바일 메뉴 하단 전화번호 --- */
  .mobile-menu-footer {
    padding: 24px;
    border-top: 1px solid #f0f0f0;
    margin-top: 16px;
  }

  .mobile-phone-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 14px 20px;
    min-height: 52px;
    font-family: var(--font-paperlogy);
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    background: var(--ecofore-primary);
    border-radius: 8px;
    text-decoration: none;
    letter-spacing: 1px;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-phone-btn:active {
    opacity: 0.85;
  }

  .mobile-phone-btn svg {
    flex-shrink: 0;
  }
}

/* ============================================
   초소형 모바일 (max-width: 380px)
   ============================================ */
@media (max-width: 380px) {
  .top-inner {
    padding: 0 12px;
    min-height: 54px;
  }

  .logo-img {
    height: 20px;
  }

  .hamburger-btn {
    width: 36px;
    height: 36px;
  }

  .phone-btn {
    width: 36px;
    height: 36px;
  }

  .phone-btn svg {
    width: 16px;
    height: 16px;
  }

  .mobile-menu {
    padding-top: 54px;
  }

  .mobile-menu-inner {
    min-height: calc(100vh - 54px);
  }

  .mobile-menu-title {
    padding: 14px 20px;
    font-size: 16px;
  }

  .mobile-sub-link {
    padding: 12px 20px 12px 36px;
    font-size: 14px;
  }

  .mobile-phone-btn {
    font-size: 16px;
    padding: 12px 16px;
  }
}
</style>
